"use client";
import { anatomy } from "@zag-js/radio-group";
//#region src/components/segment-group/segment-group.anatomy.ts
var segmentGroupAnatomy = anatomy.rename("segment-group");
var parts = segmentGroupAnatomy.build();
//#endregion
export { parts, segmentGroupAnatomy };
